import { 
    FILTER_SIDEBAR_STATE, 
    FILTER_SIDEBAR_SIZED, 
    FILTER_BUILDER_TOOLS_STATE, 
    FILTER_AI_STATE, 
    FILTER_WIKI_STATE, 
    FILTER_LIST_STATE, 
    SAVE_FILTERS_STATE, 
    SAVE_FIELDS_STATE, 
    SAVE_DOCS_STATE, 
    SAVE_DOCSDATA_STATE, 
    SAVE_ANALYSIS_STATE, 
    SAVE_FAVOURITES_STATE, 
    SAVE_COLLECTIONS_STATE, 
    SAVE_TTC_STATE 
} from "@/store/mutation-types";
export default {
    actions: {
        saveFilterSidebarState: ({ state, commit, dispatch }, payload) => {
            return new Promise((resolve) => {
                if(state.filterSidebarSized){
                    dispatch("saveFilterSidebarSize", false);
                }
                commit("FILTER_SIDEBAR_STATE", payload);
                resolve();
            })
        },
        saveFilterSidebarSize: ({ state, commit }, payload) => {
            return new Promise((resolve) => {
                commit("FILTER_SIDEBAR_SIZED", payload);
                /*if(payload === false){
                    if(state.filterBuilderTools){
                        commit("FILTER_BUILDER_TOOLS_STATE");
                    }
                }*/
                resolve();
            })
        },
        saveFilterBuilderToolsState: ({ commit }, payload) => {
            commit("FILTER_BUILDER_TOOLS_STATE", payload);
        },
        saveFilterAiState: ({ commit }) => {
            commit("FILTER_AI_STATE");
        },
        saveFilterWikiState: ({ commit }) => {
            commit("FILTER_WIKI_STATE");
        },
        saveFilterListState: ({ commit }) => {
            commit("FILTER_LIST_STATE");
        },
        saveFiltersState: ({ commit }, payload) => {
            commit("SAVE_FILTERS_STATE", payload);
        },
        saveFieldsState: ({ commit }, payload) => {
            commit("SAVE_FIELDS_STATE", payload);
        },
        saveTtcState: ({ commit }, payload) => {
            commit("SAVE_TTC_STATE", payload);
        },
        saveDocsState: ({ commit }, payload) => {
            commit("SAVE_DOCS_STATE", payload);
        },
        saveDocsDatasState: ({ commit }, payload) => {
            commit("SAVE_DOCSDATA_STATE", payload);
        },
        saveAnalysisState: ({ commit }, payload) => {
            commit("SAVE_ANALYSIS_STATE", payload);
        },
        saveFavouritesState: ({ commit }, payload) => {
            commit("SAVE_FAVOURITES_STATE", payload);
        },
        saveCollectionsState: ({ commit }, payload) => {
            commit("SAVE_COLLECTIONS_STATE", payload);
        }
    },
    getters: {
    },
    mutations: {
        [FILTER_SIDEBAR_STATE](state, payload) {
            state.filterSidebarState = payload;
        },
        [FILTER_SIDEBAR_SIZED](state, payload) {
            state.filterSidebarSized = payload;
        },
        [FILTER_BUILDER_TOOLS_STATE](state, payload) {
            if(payload === "open"){
                state.filterBuilderTools = payload;
            }
            else{
                state.filterBuilderTools = !state.filterBuilderTools;
            }
        },
        [FILTER_AI_STATE](state) {
            state.filterAi = !state.filterAi;
        },
        [FILTER_WIKI_STATE](state) {
            state.filterWikis = !state.filterWikis;
        },
        [FILTER_LIST_STATE](state) {
            state.filterList = !state.filterList;
        },
        [SAVE_FILTERS_STATE](state, payload) {
            state.filtersState = payload;
        },
        [SAVE_DOCS_STATE](state, payload) {
            state.docsState = payload;
        },
        [SAVE_DOCSDATA_STATE](state, payload) {
            state.docsDataState = payload;
        },
        [SAVE_TTC_STATE](state, payload) {
            state.ttcState = payload;
        },
        [SAVE_FIELDS_STATE](state, payload) {
            state.fieldsState = payload;
        },
        [SAVE_ANALYSIS_STATE](state, payload) {
            state.analysisState = payload;
        },
        [SAVE_FAVOURITES_STATE](state, payload) {
            state.favouritesState = payload;
        },
        [SAVE_COLLECTIONS_STATE](state, payload) {
            state.collectionsState = payload;
        }
    },
    state: {
        filtersState: true,
        filterSidebarState: false,
        filterSidebarSized: false,
        filterBuilderTools: false,
        filterWikis: false,
        filterAi: true,
        filterList: true,
        fieldsState: true,
        ttcState: true,
        docsState: true,
        docsDataState: true,
        analysisState: true,
        favouritesState: true,
        collectionsState: true
    }
};
